module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/error404_f47d37b.png";